<template>
    <div id="demoporoject-create" class="modal inmodal fade" role="" aria-hidden="true" data-backdrop="static" tabindex="-1" :style="visible ? 'display: block;' : 'display: none;'">
        <div class="modal-dialog modal-md">
            <div class="modal-content animated fadeInUp">
                <div class="modal-body scrollBox">
                    <p style="font-size:1.1em;">{{ t_create_demo_project }}<br>
                    {{ t_hint }}<br>
                    <div v-if="!loading" class="btn btn-primary" @click="createDemoProject()">{{ t_ok }}</div>
                    <div v-if="loading" class="btn btn-primary disabled"><i class="fa-regular fa-spin fa-spinner m-r-sm"></i> {{ t_ok }}</div>
                    <div class="btn btn-white" @click="cancel()">{{ t_cancel }} </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import modalMixin from "../../common/modal-mixin";

    export default {
        mixins: [
            modalMixin,
        ],
        data() {
            return {
                t_cancel: Lang.langGet("Cancel"),
                t_ok: Lang.langGet("Ok"),
                t_create_demo_project: Lang.langGet("Do you want to create a demo project?"),
                t_hint: Lang.langGet("Each user is limited to one demo project."),
                content: '',
                mode: 'add',
                ssoOverride: false,
                loading: false,

                modalName: 'demoproject-create',
            }
        },
        methods: {
            cancel: function () {
                EaseEventBus.fire('hideModal', this.modalName);
            },
            createDemoProject: function () {
                this.loading = true;
                axios.post('project-selection/demo', {
                    sso_add_project: this.ssoOverride,
                }).then((response) => {
                    this.loading = false;
                    if (response.data.total === 1) {
                        window.location = '/';
                    } else {
                        location.reload();
                    }
                }).catch((error) => {
                    this.loading = false;

                    if (error.response.status === 401) {
                        window.location = '/login';
                    }
                });
            },
        },
        mounted() {
            EaseEventBus.listen('createDemo', (data) => {
                this.ssoOverride = data;
                EaseEventBus.fire('showModal', this.modalName);
            })
        }
    }
</script>
